import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { ShareClass } from '../../types/share-classes.types';
import { useAppQuery } from '../use-app-query.hook';

export const useShareClass = ({
  companyId,
  shareClassId,
}: {
  companyId: string;
  shareClassId: string;
}) => {
  const queryClient = useQueryClient();

  const { data: shareClass, isLoading } = useAppQuery<ShareClass>({
    queryKey: [QueryKey.GET_SHARE_CLASS, companyId, shareClassId],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'share-classes', shareClassId],
      }),
    enabled: !!companyId && !!shareClassId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_SHARE_CLASS] });
  }, [queryClient]);

  return {
    invalidateQuery,
    shareClass,
    isLoading,
  };
};
